/**
 * PWA-helpers: service-worker registratie, update-detectie, install-prompt state.
 * Iedere helper is defensief: als de browser geen SW ondersteunt (bv. HTTP dev,
 * of iOS/Safari edge cases), faalt de app niet.
 */

const SW_URL = "/service-worker.js";

/** Registreer de SW. Retourneert de registration of null. */
export async function registerServiceWorker(onUpdateReady) {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return null;
  // Alleen op HTTPS of localhost. In het CRA-dev-serverproxy: SW werkt niet
  // voor api-calls, dus we skippen in development om verwarring te voorkomen.
  if (window.location.hostname !== "localhost" && window.location.protocol !== "https:") return null;
  try {
    const reg = await navigator.serviceWorker.register(SW_URL);
    reg.addEventListener("updatefound", () => {
      const nw = reg.installing;
      if (!nw) return;
      nw.addEventListener("statechange", () => {
        if (nw.state === "installed" && navigator.serviceWorker.controller) {
          // Nieuwe versie klaar en oude SW controleert nog de pagina → banner tonen.
          onUpdateReady?.(reg);
        }
      });
    });
    // Als er al een waiting SW is (bv. bij herstart), meteen aankondigen.
    if (reg.waiting && navigator.serviceWorker.controller) onUpdateReady?.(reg);
    return reg;
  } catch (_) {
    return null;
  }
}

/** Activeer de wachtende SW en herlaad de pagina eenmaal (bewuste actie na user click). */
export function activateWaitingWorker(reg) {
  if (!reg?.waiting) return;
  reg.waiting.postMessage("SKIP_WAITING");
  let refreshed = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshed) return;
    refreshed = true;
    window.location.reload();
  });
}

/** True als de app al als PWA draait (standalone). */
export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

/** iOS Safari detectie — geen beforeinstallprompt, dus we tonen handleiding. */
export function isIos() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
}


/** Wist de per-user API-read-cache in de SW. Aanroepen bij login én logout
 *  zodat gecachete data van gebruiker A nooit aan gebruiker B lekt. */
export async function clearReadCache() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const target = reg.active || navigator.serviceWorker.controller;
    if (target) target.postMessage("CLEAR_READ_CACHE");
  } catch (_) { /* silent */ }
}
